import React, { useEffect, useState } from 'react'
import './ProductCatlog.css'
import axios from 'axios'
import GetSingleProduct from '../GetSingleProduct'
import ReactPaginate from "react-paginate";
import Sellernav from '../Sellernav';
import BaseURL from '../../Util/BaseURL';
const ProductCatlog = () => {
const [pageNumber, setPageNumber] = useState(0);
    var path=window.location.pathname
    const productsPerPage = 8;
    const pagesVisited = pageNumber * productsPerPage;
    const [pageCount,setPageCount] = useState()

    const changePage = ({ selected }) => {
      setPageNumber(selected);
    };
const [products,setProducts] = useState();
    const getProducts = async () => {
    const response = await axios.get(`${BaseURL}GetPrice?sellerid=${sessionStorage.getItem("user")}&size=${productsPerPage}&startPage=${pageNumber}`,{ headers: { "Authorization": "Bearer " + sessionStorage.getItem("pic") } })  
      setProducts(response.data)
      setPageCount(Math.ceil(response.data.totalPages))
        setProducts(response.data.content)
    }
    useEffect(() => {
      getProducts();
    }, [pageNumber]);  
  return (
    <>
    {/* <div className='text-center'>
            <input id='search' className="searchProd" type="text" placeholder="Search for products, brand and more" name="search" value={search} 
            onChange={(e)=>setSeach(e.target.value)}/>
    </div> */}
    <Sellernav/>
    <section id="hero">
                <div className="hero-container">
                    <div className="hero-logo row">
                     {
                           path==="/SellerPanel/SalesReport"?
                           <h1 className="font-weight-bold col">Sales</h1>:<h1 className="font-weight-bold col">Update Catlog</h1>
                     } 
                    </div>
                </div>
            </section>
            <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 total h-100 w-100 mx-auto">
            {products
            ? products.map((data,key) => (
              <GetSingleProduct key={key} data={data.productid} />
            )):""}
              </div>
              <div className='totalpagebtn h-100 w-100'>
        <ReactPaginate
        previousLabel={<i className="fas fa-angle-double-left"></i>}
        nextLabel= {<i className="fas fa-angle-double-right"></i>}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}/>
        </div>
    </>
  )
}

export default ProductCatlog